import { Component } from '@angular/core';
import {DSA} from '../DSAalgorithm/DSA';
import {Signature} from '../DSAalgorithm/Signature';
import * as bigInt from 'big-integer';

@Component({

  selector: 'verify',
  templateUrl: 'verify.component.html',
  styleUrls: ['verify.component.scss']
})
export class VerifyComponent {
    message: string;
    privateKey: string;
    openKey: string;
    signR: string;
    signS: string;
    isVerified: string;
   verify():void{
    const dsa = new DSA();
    var isVerified =  dsa.verify(this.message, new Signature(bigInt(this.signR,16), 
                                                       bigInt(this.signS, 16),
                                                       bigInt(this.openKey, 16)));
  
    if(isVerified==true)
      this.isVerified ="Текст подлинный";
    else
      this.isVerified="Текст подделан";
    console.log('ok');
    }
  }